import { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/config";

export const useVerificationEmail = () => {
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);

  const sentConfirmationEmail = async (email) => {
    setError(null);
    setIsPending(true);

    try {
      // signup user
      const res = await httpsCallable(
        functions,
        "verificationEmail"
      )({
        email
      });
  
      if (!res) {
        throw new Error("could not complete stations");
      }

      setIsPending(false);
      setError(null);
      return res;
    } catch (err) {
      console.log(err.message);
      setError(err.message);
      setIsPending(false);
    }
  };

  return { error, isPending, sentConfirmationEmail };
};
